import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as CampaignsIcon } from '@/assets/images/icons/campaigns.svg';
import { ReactComponent as ConstituentsIcon } from '@/assets/images/icons/constituents.svg';
import { ReactComponent as HomeIcon } from '@/assets/images/icons/home.svg';
import { ReactComponent as IntegrationsIcon } from '@/assets/images/icons/integrations.svg';
import { ReactComponent as LifecycleBoardsIcon } from '@/assets/images/icons/lifecycle-boards.svg';
import { ReactComponent as OpportunitiesIcon } from '@/assets/images/icons/opportunities.svg';
import { ReactComponent as ReportsIcon } from '@/assets/images/icons/reports.svg';
import { ReactComponent as SettingsIcon } from '@/assets/images/icons/settings.svg';
import { ReactComponent as SuperAdminIcon } from '@/assets/images/icons/super-admin.svg';
import { ReactComponent as TasksIcon } from '@/assets/images/icons/tasks.svg';

const iconTypes = {
  admin: SuperAdminIcon,
  campaigns: CampaignsIcon,
  company: SettingsIcon,
  constituents: ConstituentsIcon,
  home: HomeIcon,
  integrations: IntegrationsIcon,
  lifecycleBoards: LifecycleBoardsIcon,
  opportunities: OpportunitiesIcon,
  reports: ReportsIcon,
  tasks: TasksIcon,
};

function NavigationIcon({ className, name }) {
  const DynamicIcon = iconTypes[name];

  return <DynamicIcon className={className} />;
}

NavigationIcon.propTypes = {
  className: PropTypes.string.isRequired,
  name: PropTypes.node,
};

NavigationIcon.defaultProps = {
  name: '',
};

export default NavigationIcon;
